import React, { useEffect, useState } from "react";
import {
    QrCode,
    Share,
    Phone,
    Mail,
    MessageCircle,
    Globe,
    MapPin,
    X,
    Star,
} from "lucide-react";

import styles from "./cleberluiz57.module.scss"; // SCSS Modules
import Hero from "./src/hero.png";
import QrCodeImage from "./src/qrCodeImage.png";
import Contact from "./src/contact.vcf";

const Cleberluiz57: React.FC = () => {
    const [showQR, setShowQR] = useState(false);
    const [showSendCard, setShowSendCard] = useState(false);
    const [formData, setFormData] = useState({ phone: "" });
    const [pageHeight, setPageHeight] = useState<number>(window.innerHeight);

    useEffect(() => {
        const updateHeight = () => {
            // mede o documento inteiro (inclui elementos absolutos fora do fluxo)
            const height = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight,
                document.body.offsetHeight,
                document.documentElement.offsetHeight,
                document.documentElement.clientHeight
            );
            setPageHeight(height);
        };

        updateHeight(); // inicial
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const cleaned = value.replace(/\D/g, ""); // só números
            let masked = cleaned;

            if (cleaned.length > 0) masked = `(${cleaned.slice(0, 2)}`;
            if (cleaned.length >= 3) masked += `) ${cleaned.slice(2, 7)}`;
            if (cleaned.length >= 8) masked += `-${cleaned.slice(7, 11)}`;

            setFormData((prev) => ({
                ...prev,
                phone: masked,
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSendCard = () => {
        const cleaned = formData.phone.replace(/\D/g, "");
        if (cleaned.length !== 11) {
            alert("Digite um número válido com DDD. Exemplo: (11) 91234-5678");
            return;
        }

        const phoneWithCountry = `55${cleaned}`;
        const message =
            "Olá, segue meu cartão digital https://www.linkvibes.com.br/cleberluiz57";

        window.open(
            `https://wa.me/${phoneWithCountry}?text=${encodeURIComponent(message)}`,
            "_blank"
        );
    };

    return (
        <div className={styles.cleberluiz57}>
            <div className={styles.home} style={{ minHeight: `${pageHeight}px` }}>
                {/* Header */}
                <div className={styles.header}>
                    <div className={styles.card}>
                        {/* Imagem perfil */}
                        <div className={styles["profile-image"]}>
                            <img src={Hero} alt="Hero" />
                        </div>

                        <h2 className={styles.name}>Cleber Luiz Pereira</h2>
                        <p className={styles.role}>Advogado</p>

                        {/* Primeira row */}
                        <div className={styles.row}>
                            <div
                                className={styles.action}
                                onClick={() => setShowQR(!showQR)}
                            >
                                <QrCode className={styles.icon} />
                                <span>Modo Offline</span>
                            </div>

                            <a
                                href={Contact}
                                download="Cleber_Luiz.vcf"
                                className={styles.btn}
                            >
                                Salvar na Agenda
                            </a>

                            <div
                                className={styles.action}
                                onClick={() => setShowSendCard(true)}
                            >
                                <Share className={styles.icon} />
                                <span>Enviar Cartão</span>
                            </div>
                        </div>

                        {/* QR Code expandido */}
                        {showQR && (
                            <div className={styles["qr-box"]}>
                                <p className={styles["qr-title"]}>Modo Offline</p>
                                <img src={QrCodeImage} className="mb-4" alt="QR Code Contato" />
                                <p className="mb-0">Acesse para salvar diretamente na agenda.</p>
                            </div>
                        )}

                        <div className={styles.divider}></div>

                        {/* Segunda row */}
                        <div className={styles.row}>
                            <a href="tel:+551741010040" className={styles.action}>
                                <Phone className={styles.icon} />
                                <span>Ligar</span>
                            </a>
                            <a
                                href="mailto:cll.pereira@hotmail.com"
                                className={styles.action}
                            >
                                <Mail className={styles.icon} />
                                <span>E-mail</span>
                            </a>
                            <a
                                href="https://wa.me/5517981227725?text=Olá, Vim pelo seu cartão digital e gostaria de mais informações..."
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.action}
                            >
                                <MessageCircle className={styles.icon} />
                                <span>Whatsapp</span>
                            </a>
                        </div>

                        <div className={styles.divider}></div>

                        <p className={styles.description}>
                            Defendendo seus direitos com excelência, ética e compromisso. Sua
                            confiança é nossa maior responsabilidade.
                        </p>

                        <div className={styles.divider}></div>

                        {/* Botões */}
                        <div className={styles["btn-group"]}>
                            <a href="https://cleberluizpereira-advocacia.escritorio-online.com/" target="_blank">
                                <button className={`${styles.btn} ${styles.full}`}>
                                    <Globe className={styles.icon} /> Acesse meu site
                                </button>
                            </a>
                            <a href="https://maps.app.goo.gl/BUzxw1kaECjqmZmo7" target="_blank">
                                <button className={`${styles.btn} ${styles.full}`}>
                                    <MapPin className={styles.icon} /> Localização
                                </button>
                            </a>
                            <a href="https://g.page/r/CRchHYPibV2yEAE/review" target="_blank">
                                <button className={`${styles.btn} ${styles.full}`}>
                                    <Star className={styles.icon} /> Me avalie no Google
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Modal de Enviar Cartão */}
                {showSendCard && (
                    <div className={styles.modal}>
                        <div className={styles["modal-content"]}>
                            <button
                                onClick={() => setShowSendCard(false)}
                                className={styles.close}
                            >
                                <X className={styles.icon} />
                            </button>

                            <p className="mb-0">
                                Digite o DDD do estado + Número do WhatsApp para enviar seu cartão
                                de visita:
                            </p>

                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="(xx) xxxxx-xxxx"
                                maxLength={19}
                            />

                            <button
                                type="button"
                                onClick={handleSendCard}
                                className={`${styles.btn} ${styles.full}`}
                            >
                                Enviar Cartão
                            </button>

                            <div className={styles["text-center"]}>
                                <a
                                    href="https://wa.me/?text=Olá%2C%20segue%20meu%20cartão%20digital https://www.linkvibes.com.br/cleberluiz57"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.link}
                                >
                                    Selecionar Contato
                                </a>
                            </div>
                        </div>
                    </div>
                )}

                <div className={styles["flex-fill"]}></div>
            </div>
        </div>
    );
};

export default Cleberluiz57;
